/**
 * @fileoverview GET handler for the "/oauth/validate_developer_permissions" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { oauthValidateDeveloperPermissions } from "./constants";
import type {
  OAuthValidateDeveloperPermissionsResult,
  OAuthValidateDeveloperPermissionsResultErrors,
} from "./types";
import { isOAuthValidateDeveloperPermissionsResult } from "./validators";

export const getOAuthValidateDeveloperPermissions = reactQueryFetcherAdapter(
  oauthValidateDeveloperPermissions,
  createGetFetcherFunctionWithShadowError<OAuthValidateDeveloperPermissionsResultErrors>()(
    (signal: AbortSignal, scopes: string[]): Promise<OAuthValidateDeveloperPermissionsResult> => {
      return fetch(
        "/oauth/validate_developer_permissions",
        "GET",
        { scopes },
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isOAuthValidateDeveloperPermissionsResult
);
